// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// TODO NEXT - LEGO-9370 - refactor this so it's two separate functions. No need to combine this stuff

const getPathMetaInfo = (withinProjectSummary, projectSummary, user) => {
  // if there's a default company, pass an object literal of its values,
  // not an immutable Map
  const company = (
    withinProjectSummary && projectSummary.get('defaultCompany')
      ? projectSummary.get('defaultCompany').toJS()
      : null
  )
  const contact = (
    withinProjectSummary && projectSummary.get('defaultContact')
      ? projectSummary.get('defaultContact').toJS()
      : null
  )

  const domainId = user.get('userDomain')

  // find the matching path id from project summary in state.
  // then define:
  // the index of this path
  // the path id of the previous path
  // and the path after this one.
  // if there are any
  const pathPlacement = {
    nextPathId: null,
    pathIndex: 'n/a',
    // this allows for the last path to act as 'previous path' when we're on a new path form
    prevPathId: null,
  }

  const projectId = (
    withinProjectSummary
      ? projectSummary.get('projectId')
      : null
  )

  const projectTypeId = (
    withinProjectSummary
      ? projectSummary.getIn(['projectType', 'projectTypeId'])
      : null
  )

  // if we're in the project summary, get the unitType for this form from the
  // project's settings, otherwise get it from the user's settings
  const unitType = (
    withinProjectSummary
      ? projectSummary.get('unitType')
      : user.getIn(['defaultUnitType', 'unitType'])
  )

  return {
    company,
    contact,
    domainId,
    pathPlacement,
    projectId,
    projectTypeId,
    unitType,
  }
}

export default getPathMetaInfo
